export default __webpack_public_path__ + "static/media/window-no-clouds.1fc3758d.jpg";